"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rendall API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgentRowV2ToJSON = exports.AgentRowV2FromJSONTyped = exports.AgentRowV2FromJSON = exports.instanceOfAgentRowV2 = void 0;
var runtime_1 = require("../runtime");
var AgentGeoLocation_1 = require("./AgentGeoLocation");
var AgentHealthCheck_1 = require("./AgentHealthCheck");
var AgentIdentity_1 = require("./AgentIdentity");
var AgentInstalledModule_1 = require("./AgentInstalledModule");
var AgentStatusV2_1 = require("./AgentStatusV2");
var AgentVDIState_1 = require("./AgentVDIState");
var ModuleVersionsMap_1 = require("./ModuleVersionsMap");
var PlatformOSType_1 = require("./PlatformOSType");
var SystemInfo_1 = require("./SystemInfo");
/**
 * Check if a given object implements the AgentRowV2 interface.
 */
function instanceOfAgentRowV2(value) {
    var isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "version" in value;
    isInstance = isInstance && "hostname" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "osName" in value;
    isInstance = isInstance && "sysmonVersion" in value;
    isInstance = isInstance && "ipAddresses" in value;
    isInstance = isInstance && "macAddresses" in value;
    isInstance = isInstance && "lastReported" in value;
    isInstance = isInstance && "lastUser" in value;
    isInstance = isInstance && "lastHealthyTime" in value;
    isInstance = isInstance && "wazuhStatus" in value;
    isInstance = isInstance && "isDegraded" in value;
    isInstance = isInstance && "scanGroups" in value;
    isInstance = isInstance && "systemInfo" in value;
    isInstance = isInstance && "isContainmentModuleAssignable" in value;
    isInstance = isInstance && "moduleVersions" in value;
    return isInstance;
}
exports.instanceOfAgentRowV2 = instanceOfAgentRowV2;
function AgentRowV2FromJSON(json) {
    return AgentRowV2FromJSONTyped(json, false);
}
exports.AgentRowV2FromJSON = AgentRowV2FromJSON;
function AgentRowV2FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'version': json['version'],
        'hostname': json['hostname'],
        'status': (0, AgentStatusV2_1.AgentStatusV2FromJSON)(json['status']),
        'firstSeen': !(0, runtime_1.exists)(json, 'firstSeen') ? undefined : (new Date(json['firstSeen'])),
        'osName': json['osName'],
        'sysmonVersion': json['sysmonVersion'],
        'ipAddresses': json['ipAddresses'],
        'macAddresses': json['macAddresses'],
        'installedModules': !(0, runtime_1.exists)(json, 'installedModules') ? undefined : (json['installedModules'].map(AgentInstalledModule_1.AgentInstalledModuleFromJSON)),
        'vdiState': !(0, runtime_1.exists)(json, 'vdiState') ? undefined : (0, AgentVDIState_1.AgentVDIStateFromJSON)(json['vdiState']),
        'lastReported': (new Date(json['lastReported'])),
        'lastUser': json['lastUser'],
        'lastHealthyTime': json['lastHealthyTime'],
        'wazuhStatus': json['wazuhStatus'],
        'isDegraded': json['isDegraded'],
        'scanGroups': json['scanGroups'],
        'systemInfo': (0, SystemInfo_1.SystemInfoFromJSON)(json['systemInfo']),
        'platformOS': !(0, runtime_1.exists)(json, 'platformOS') ? undefined : (0, PlatformOSType_1.PlatformOSTypeFromJSON)(json['platformOS']),
        'isContainmentModuleAssignable': json['isContainmentModuleAssignable'],
        'moduleVersions': (0, ModuleVersionsMap_1.ModuleVersionsMapFromJSON)(json['moduleVersions']),
        'healthCheck': !(0, runtime_1.exists)(json, 'healthCheck') ? undefined : (0, AgentHealthCheck_1.AgentHealthCheckFromJSON)(json['healthCheck']),
        'identity': !(0, runtime_1.exists)(json, 'identity') ? undefined : (0, AgentIdentity_1.AgentIdentityFromJSON)(json['identity']),
        'geoLocation': !(0, runtime_1.exists)(json, 'geoLocation') ? undefined : (0, AgentGeoLocation_1.AgentGeoLocationFromJSON)(json['geoLocation']),
    };
}
exports.AgentRowV2FromJSONTyped = AgentRowV2FromJSONTyped;
function AgentRowV2ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'version': value.version,
        'hostname': value.hostname,
        'status': (0, AgentStatusV2_1.AgentStatusV2ToJSON)(value.status),
        'firstSeen': value.firstSeen === undefined ? undefined : (value.firstSeen.toISOString()),
        'osName': value.osName,
        'sysmonVersion': value.sysmonVersion,
        'ipAddresses': value.ipAddresses,
        'macAddresses': value.macAddresses,
        'installedModules': value.installedModules === undefined ? undefined : (value.installedModules.map(AgentInstalledModule_1.AgentInstalledModuleToJSON)),
        'vdiState': (0, AgentVDIState_1.AgentVDIStateToJSON)(value.vdiState),
        'lastReported': (value.lastReported.toISOString()),
        'lastUser': value.lastUser,
        'lastHealthyTime': value.lastHealthyTime,
        'wazuhStatus': value.wazuhStatus,
        'isDegraded': value.isDegraded,
        'scanGroups': value.scanGroups,
        'systemInfo': (0, SystemInfo_1.SystemInfoToJSON)(value.systemInfo),
        'platformOS': (0, PlatformOSType_1.PlatformOSTypeToJSON)(value.platformOS),
        'isContainmentModuleAssignable': value.isContainmentModuleAssignable,
        'moduleVersions': (0, ModuleVersionsMap_1.ModuleVersionsMapToJSON)(value.moduleVersions),
        'healthCheck': (0, AgentHealthCheck_1.AgentHealthCheckToJSON)(value.healthCheck),
        'identity': (0, AgentIdentity_1.AgentIdentityToJSON)(value.identity),
        'geoLocation': (0, AgentGeoLocation_1.AgentGeoLocationToJSON)(value.geoLocation),
    };
}
exports.AgentRowV2ToJSON = AgentRowV2ToJSON;
